import {
  CheckPriceProps,
  useExistingProductState,
} from "Components/Features/CheckPrice";
import {
  AKA_STUDENT_ABOUT_YOU_STEP,
  AKA_STUDENT_PRICE_STEP,
  AKA_STUDENT_STEPS,
} from "./akaStudentSteps";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { ActiveStep } from "Components/ActiveStep";
import { ProductTile } from "Components/Features/CheckPrice/Tiles/ProductTile";
import { useTexts } from "Components/TextContext";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import React from "react";
import { Route } from "react-router";
import { ProductBackendName } from "../../productTypes";
import { AkaStudentProductIntro } from "./ProductIntro";
import { AkaStudentProductPrice } from "./ProductPrice";
import { PATH } from "./akaStudentConstants";

export const AkaStudentCheckPrice = ({
  updatePriceRequest,
}: CheckPriceProps): React.ReactElement => {
  const { getText } = useTexts();
  useExistingProductState(INSURANCE_NAME_VALUE.AKA_STUDENT);

  return (
    <ProductTile
      productName={getText("insuranceproduct.akastudent.name")}
      productBackendName={ProductBackendName.AKA_STUDENT}
      productPath={PATH}
      productSteps={AKA_STUDENT_STEPS}
      title={getText("insuranceproduct.akastudent.name")}
      iconName={Icons.TRAVEL}
    >
      <Route
        exact
        path={`${PATH}/${AKA_STUDENT_ABOUT_YOU_STEP.id}`}
        render={() => (
          <ActiveStep>
            <AkaStudentProductIntro updatePriceRequest={updatePriceRequest} />
          </ActiveStep>
        )}
      />

      <Route
        exact
        path={`${PATH}/${AKA_STUDENT_PRICE_STEP.id}`}
        render={() => (
          <ActiveStep>
            <AkaStudentProductPrice />
          </ActiveStep>
        )}
      />
    </ProductTile>
  );
};
